var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "componentContainer",
      staticClass: "component-container",
      style: { margin: _vm.canvasPadding + "px" },
      attrs: { tabindex: "3" },
    },
    [
      _c("canvas", {
        staticClass: "timeline-canvas",
        attrs: { id: "timelineCanvas" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }